import { Body, Bold, H2, H3, Meta, PrimaryButton, SubBody, Tag, TertiaryButton } from "@rikstv/shared-components"
import { FC } from "react"
import { FlexBox } from "~/components/shared/layout/FlexBox"
import type { SanityBroadbandProduct } from "../internet.api"
import { useInternetFlowStore, type InternetServiceOrderProduct } from "../useInternetStore"

import { ReactComponent as SpeedometerSvg } from '../icons/speedometer.svg'

import { PortableText } from "@portabletext/react"
import classNames from "classnames"
import { captureUXEvent } from "~/analytics/productAnalytics"
import { DialogCloseButton } from "~/components/shared/dialog/dialog-close-button"
import { useDialog } from "~/components/shared/dialog/useDialog"
import { useMediaQuery } from "~/hooks/useMediaQuery"
import styles from './InternetProductCard.module.css'

export const InternetProductCard: FC<{ngtProduct: InternetServiceOrderProduct, sanityProduct: SanityBroadbandProduct}> = ({ ngtProduct, sanityProduct }) => {
  const isSelected = useInternetFlowStore(s => s.selectedIspProduct)?.ngt.productId === ngtProduct.productId;
  const doSelect = useInternetFlowStore(s => s.setSelectedIspProduct);
  const onSelect = () => {
    captureUXEvent('rtv_sales_select_internet_product', { productName: sanityProduct.name });
    doSelect(ngtProduct, sanityProduct);  
  }
  // dialogs
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { closeDialog, openModalDialog, ref } = useDialog();

  return (<div className={classNames(styles.container, {[styles.selected]: isSelected})}>
    <Tag className={styles.tagline}>Via Telenor-fiber</Tag>
    <FlexBox direction='column' gap={24} style={{ paddingInline: '24px', paddingBlock: '12px 40px'}} alignItems='center'>
      <SpeedometerSvg className={styles.speedometer} data-name={sanityProduct.name} />
      <H3>{sanityProduct.name}</H3>
      <FlexBox direction='column' gap={0} alignItems='center'>
        <FlexBox gap={'1ch'} alignItems='baseline'>
          <H2>{ngtProduct.productPrice},-</H2>
          <Body>/mnd i 12 mnd**</Body>
        </FlexBox>
        <Meta>Orginalpris {ngtProduct.originalProductPrice},- /mnd</Meta>
      </FlexBox>
      <SubBody as="div" className={styles.cmsText}>
        <PortableText value={sanityProduct.shortDescription} />
      </SubBody>
      <div className={styles.actions}>
        <TertiaryButton data-testid={`btn-modal-${sanityProduct.name}`} onClick={() => openModalDialog()}>Les mer</TertiaryButton>
        <PrimaryButton data-testid={`btn-select-${sanityProduct.name}`} disabled={isSelected} onClick={() => onSelect()}>{isSelected ? 'Valgt' : 'Velg'}</PrimaryButton>
      </div>
    </FlexBox>
    <dialog ref={ref}>
      <PortableText value={sanityProduct.description} />
      <br />
      <FlexBox gap={12} direction={isMobile ? 'column': 'row'} alignItems="center" justifyContent={isMobile ? undefined : 'space-between'}>
        <FlexBox direction='column' gap={0}>
          <Bold style={{color: '#00816D'}}>{ngtProduct.productPrice},- /mnd i 12 mnd</Bold>
          <Meta>Orginalpris {ngtProduct.originalProductPrice},- /mnd</Meta>
        </FlexBox>
        <PrimaryButton data-testid={`btn-modal-select-${sanityProduct.name}`} disabled={isSelected} onClick={() => {
          onSelect();
          closeDialog();
        }}>{isSelected ? 'Valgt' : 'Velg'}</PrimaryButton>
      </FlexBox>
      <DialogCloseButton onClick={() => closeDialog()} />
    </dialog>
  </div>)
}